// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-members__title{
    padding: var(--space-half) var(--space-and-half) var(--space-half) var(--space-and-half);
    color: var(--primary-very-dark-color) !important;
    font-weight: var(--font-regular) !important;
}

.team-members__container{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    /* gap: var( --grid-gap ); */
    grid-template-areas: "left right";
    align-items: baseline;
}

.team-members__list{
    grid-area: left;
    margin-left: var(--space-and-half);
    border: 1px solid var(--primary-light-color);
    border-radius: 4px;
}

.team-members__list__title{
    padding: var(--space-half) var(--space) var(--space-half) var(--space);
    color: var(--primary-very-dark-color) !important;
    border-bottom: 1px solid var(--primary-light-color);
}

.team-members__form{
    grid-area: right;
    max-height: calc(100vh - 100px);
}

.team-members__list__container{
    /* max-height: 480px; */
    max-height: calc(100vh - 140px);
}

.team-members__list__container__user{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: var(--space-half-quarter);
    border-bottom: 1px solid var(--primary-light-color);
    cursor: pointer;
}

.team-members__list__container__user .icon-ompleted-form img{
    width: 20px;
    height: 20px;
}

.team-members__list__container__user__info{
    display: flex;
    padding: var(--space-half-quarter) var(--space) var(--space-half-quarter) var(--space);
}

.selected__user{
    background-color: var(--new-gray-background-color);
}

.team-members__list__container__user__info .baloa-username{
    align-items: center;
    display: flex;
    color: var(--primary-dark-color);
}

.team-members__list__container__user__info .baloa-username.disabled {
    color: var(--primary-color);
}

.team-members__list__container__user__info img {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    margin-right: 12px;
}

.team-members__list__container__user__info .icon-ball{
    color: var(--white-color);
    font-size: 30px;
    padding: 4px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
}

.team-members__view-more-link.baloa-names {
    color: var(--new-green-color);
    text-align: center;
    cursor: pointer;
    position: sticky;
    bottom: -1px;
    background: var(--white-color);
    padding: 8px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/answer-multiple-forms-modal/AnswerMultipleFormsModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,wFAAwF;IACxF,gDAAgD;IAChD,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB,4BAA4B;IAC5B,iCAAiC;IACjC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,sEAAsE;IACtE,gDAAgD;IAChD,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wCAAwC;IACxC,mDAAmD;IACnD,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sFAAsF;AAC1F;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,cAAc;AAClB","sourcesContent":[".team-members__title{\n    padding: var(--space-half) var(--space-and-half) var(--space-half) var(--space-and-half);\n    color: var(--primary-very-dark-color) !important;\n    font-weight: var(--font-regular) !important;\n}\n\n.team-members__container{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    /* gap: var( --grid-gap ); */\n    grid-template-areas: \"left right\";\n    align-items: baseline;\n}\n\n.team-members__list{\n    grid-area: left;\n    margin-left: var(--space-and-half);\n    border: 1px solid var(--primary-light-color);\n    border-radius: 4px;\n}\n\n.team-members__list__title{\n    padding: var(--space-half) var(--space) var(--space-half) var(--space);\n    color: var(--primary-very-dark-color) !important;\n    border-bottom: 1px solid var(--primary-light-color);\n}\n\n.team-members__form{\n    grid-area: right;\n    max-height: calc(100vh - 100px);\n}\n\n.team-members__list__container{\n    /* max-height: 480px; */\n    max-height: calc(100vh - 140px);\n}\n\n.team-members__list__container__user{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-right: var(--space-half-quarter);\n    border-bottom: 1px solid var(--primary-light-color);\n    cursor: pointer;\n}\n\n.team-members__list__container__user .icon-ompleted-form img{\n    width: 20px;\n    height: 20px;\n}\n\n.team-members__list__container__user__info{\n    display: flex;\n    padding: var(--space-half-quarter) var(--space) var(--space-half-quarter) var(--space);\n}\n\n.selected__user{\n    background-color: var(--new-gray-background-color);\n}\n\n.team-members__list__container__user__info .baloa-username{\n    align-items: center;\n    display: flex;\n    color: var(--primary-dark-color);\n}\n\n.team-members__list__container__user__info .baloa-username.disabled {\n    color: var(--primary-color);\n}\n\n.team-members__list__container__user__info img {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    margin-right: 12px;\n}\n\n.team-members__list__container__user__info .icon-ball{\n    color: var(--white-color);\n    font-size: 30px;\n    padding: 4px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 12px;\n}\n\n.team-members__view-more-link.baloa-names {\n    color: var(--new-green-color);\n    text-align: center;\n    cursor: pointer;\n    position: sticky;\n    bottom: -1px;\n    background: var(--white-color);\n    padding: 8px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
